// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","274":"20607c19","434":"6c649c4d","458":"ec94b2b4","577":"66801e42","652":"34876035","682":"d5252985","716":"148aee88","783":"c66ca607","812":"e16e9c63","867":"942b9eea","904":"0c67cfd9","985":"de897744","997":"f8c56c24"}[chunkId] + ".js";
};